'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
var index$1 = require('../../00.helper/FormField/index.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var Icon = require('../Icon/Icon.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-checkbox',
    cnInput = "".concat(CLASSNAME, "__input"),
    cnIcon = "".concat(CLASSNAME, "__icon"),
    cnTitle = "".concat(CLASSNAME, "__title"),
    cnLabel = "".concat(CLASSNAME, "__label"),
    cnContenWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnDescription = "".concat(CLASSNAME, "__description"),
    cnRequired = "".concat(CLASSNAME, "__required"),
    cnWrapperLabel = "".concat(CLASSNAME, "__wrapper-label"),
    cnWrapperInput = "".concat(CLASSNAME, "__wrapper-input"),
    cnChecker = "".concat(CLASSNAME, "__checker"),
    cnError = "".concat(CLASSNAME, "--error"),
    cnFocus = "".concat(CLASSNAME, "--focus"),
    cnDisabled = "".concat(CLASSNAME, "--disabled");
/**
 * 
 */

var Checkbox = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(Checkbox, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(Checkbox);

  function Checkbox() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, Checkbox);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {});

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onFocus", function () {
      _this.setState({
        focus: true
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "onBlur", function (e) {
      var error = _this.state.error;

      if (error) {
        _this.validate(e);
      }

      _this.setState({
        focus: false
      });
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "validate", function (e) {
      var target = e.target,
          required = _this.props.required;

      if (required && !target.validity.valid) {
        _this.setState({
          error: true
        });

        return;
      }

      _this.setState({
        error: false
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(Checkbox, [{
    key: "render",
    value: function render() {
      var _classNames,
          _this2 = this;

      var _this$props = this.props,
          className = _this$props.className,
          style = _this$props.style,
          type = _this$props.type,
          title = _this$props.title,
          label = _this$props.label,
          description = _this$props.description,
          name = _this$props.name,
          value = _this$props.value,
          required = _this$props.required,
          requiredLabel = _this$props.requiredLabel,
          optionalLabel = _this$props.optionalLabel,
          onChange = _this$props.onChange,
          checked = _this$props.checked,
          defaultChecked = _this$props.defaultChecked,
          items = _this$props.items,
          disabled = _this$props.disabled,
          _this$state = this.state,
          focus = _this$state.focus,
          error = _this$state.error,
          arr = items ? items : [{
        value: value,
        label: label,
        checked: checked,
        defaultChecked: defaultChecked
      }];
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(CLASSNAME, className, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnError, error), _rollupPluginBabelHelpers.defineProperty(_classNames, cnFocus, focus), _rollupPluginBabelHelpers.defineProperty(_classNames, cnDisabled, disabled), _classNames)),
        style: style
      }, title && /*#__PURE__*/React__default.createElement("span", {
        className: cnTitle
      }, title, /*#__PURE__*/React__default.createElement("span", {
        className: cnRequired
      }, required ? requiredLabel : optionalLabel)), arr.map(function (_ref, i) {
        var value = _ref.value,
            label = _ref.label,
            checked = _ref.checked,
            defaultChecked = _ref.defaultChecked;
        return /*#__PURE__*/React__default.createElement("label", {
          key: value || i,
          className: cnWrapperLabel
        }, /*#__PURE__*/React__default.createElement("div", {
          className: cnWrapperInput
        }, /*#__PURE__*/React__default.createElement("input", {
          className: cnInput,
          type: type,
          required: required,
          name: name,
          value: value,
          onChange: onChange,
          onFocus: _this2.onFocus,
          onBlur: _this2.onBlur,
          defaultChecked: defaultChecked,
          checked: checked,
          onInvalid: _this2.validate,
          disabled: disabled
        }), /*#__PURE__*/React__default.createElement("div", {
          className: classNames(cnChecker, "".concat(cnChecker, "--").concat(type))
        }, type === 'checkbox' && /*#__PURE__*/React__default.createElement(Icon, {
          className: cnIcon,
          id: "check",
          size: "xs"
        }))), /*#__PURE__*/React__default.createElement("span", {
          className: cnContenWrapper
        }, label && /*#__PURE__*/React__default.createElement("span", {
          className: cnLabel
        }, label, !title && /*#__PURE__*/React__default.createElement("span", {
          className: cnRequired
        }, required ? requiredLabel : optionalLabel)), description && /*#__PURE__*/React__default.createElement("span", {
          className: cnDescription,
          dangerouslySetInnerHTML: {
            __html: description
          }
        }), !(title || label) && /*#__PURE__*/React__default.createElement("span", {
          className: cnRequired
        }, required ? requiredLabel : optionalLabel)));
      }));
    }
  }]);

  return Checkbox;
}(React__default.Component);
Checkbox.propTypes = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.propTypes), {}, {
  checked: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** */
  defaultChecked: PropTypes.bool,

  /** */
  disabled: PropTypes.bool,

  /** */
  description: PropTypes.string,
  items: PropTypes.arrayOf(PropTypes.shape({
    checked: PropTypes.bool,
    defaultChecked: PropTypes.bool,
    value: PropTypes.any,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.node])
  })),

  /** */
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),

  /** */
  name: PropTypes.string,

  /** */
  onChange: PropTypes.func,

  /** */
  required: PropTypes.bool,

  /** Additional style object */
  style: PropTypes.object,

  /** Title string */
  title: PropTypes.string,

  /** Type of checkbox */
  type: PropTypes.oneOf(['checkbox', 'radio']),

  /** */
  value: function value(props, propName, componentName) {
    if (props[propName] === false) {
      return new Error('Invalid prop `' + propName + '` supplied to' + ' `' + componentName + '`. Validation failed.');
    }

    return undefined;
  }
});
Checkbox.defaultProps = _rollupPluginBabelHelpers.objectSpread2(_rollupPluginBabelHelpers.objectSpread2({}, index$1.defaultProps), {}, {
  onChange: function onChange() {
    return void 0;
  },
  type: 'checkbox'
});

module.exports = Checkbox;
